import { apiService } from "../api.service";

// Requests
import { UpdateBussinessProfileRequest } from "../../models/api/requests";

import { Business, Location, Subscription } from "../../models/app/domain";

/**
 * Fetch business
 * @return - BussinessResponse || ErrorResponse
 */
export const fetchBusinessRequest = async () => {
  const response = await apiService.get("/businesses?with_subscription=true");
  if (response.hasError) {
    return response;
  }
  return {
    business: new Business(response.data.business),
    location: new Location(response.data.business.location),
    activeSubscription: response.data?.business?.active_subscription
      ? new Subscription(response.data.business.active_subscription)
      : undefined
  };
};

/**
 * Update business profile
 * @return - BussinessResponse || ErrorResponse
 */
export const updateBusinessProfileRequest = async (
  businessProfileFormValues,
  businessProfileInitialValues
) => {
  const payload = new UpdateBussinessProfileRequest(businessProfileFormValues);
  payload.removeSameValues(businessProfileInitialValues);
  const response = await apiService.patch("/businesses", payload);
  if (response.hasError) {
    return response;
  }
  return {
    business: new Business(response.data.business),
    location: new Location(response.data.business.location),
    activeSubscription: response.data?.business?.active_subscription
      ? new Subscription(response.data.business.active_subscription)
      : undefined
  };
};
